<template>
  <v-toolbar
    color="primary"
    fixed>
    <v-toolbar-title
      class="text-xs-center">
      <v-icon
        class="ml-3 hidden-md-and-down"
        color="white"
      >home</v-icon>
      <span class="hidden-md-and-down">
        <span class="white--text">{{ App.app_name }}</span>
      </span>
    </v-toolbar-title>
    <v-spacer/>
    <!-- center logo -->
    <img
      :src="$t('app.assets.logo')"
      width="40"
      class="hidden-md-and-up">
    <v-spacer/>
    <v-btn
      v-if="!isAuthenticated"
      color="white"
      to="/auth/login">
      <span class="white--text">{{ $t('app.general.login') }}</span>
      <v-icon
        right
        color="white">fa-sign-in</v-icon>
    </v-btn>
    <v-btn
      v-if="!isAuthenticated"
      color="white"
      to="/auth/register">
      <span class="white--text">{{ $t('app.general.register') }}</span>
      <v-icon
        right
        color="white--text">fa-user-plus</v-icon>
    </v-btn>
    <v-btn
      v-if="isAuthenticated"
      color="white"
      to="/dashboard">
      <span class="white--text">{{ $t('app.general.dashboard') }}</span>
      <v-icon
        right
        color="white">fa-tachometer</v-icon>
    </v-btn>
    <v-btn
      v-if="isAuthenticated"
      color="white"
      to="/auth/logout">
      <span class="white--text">{{ $t('app.general.logout') }}</span>
      <v-icon
        right
        color="white">fa-sign-out</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("auth");

export default {
  computed: {
    ...mapState({
      isAuthenticated: "isAuthenticated"
    })
  },
  methods: {
    toggleDrawer() {
      Bus.$emit("toggleDrawer");
    }
  }
};
</script>

<style>
</style>
